import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { IoHeart, IoHeartOutline } from 'react-icons/io5'

const WishlistButton = ({ courseId, initialWishlisted, onWishlistChange, size = "medium" }) => {
  const [wishlisted, setWishlisted] = useState(initialWishlisted)
  const [loading, setLoading] = useState(false)

  // Update state when prop changes
  useEffect(() => {
    setWishlisted(initialWishlisted)
  }, [initialWishlisted])

  const handleToggleWishlist = async (e) => {
    if (e) e.stopPropagation()
    
    const token = localStorage.getItem('jwttoken')

    if (!courseId) {
      console.error('Missing courseId.')
      return
    }

    if (!token) {
      Swal.fire({
        icon: 'warning',
        title: 'Login Required',
        text: 'Please login to add courses to your wishlist',
        confirmButtonColor: '#B8529E'
      })
      return
    }

    const url = `https://kaasbackend.vetrinahealthcare.com/lms/user/wishlist/${courseId}/`
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }

    try {
      setLoading(true)

      if (wishlisted) {
        // Remove from wishlist
        const response = await axios.delete(url, { headers })
        console.log('Delete response:', response.data)
        Swal.fire({
          icon: 'success',
          title: 'Removed!',
          text: 'Course removed from wishlist',
          timer: 1500,
          showConfirmButton: false
        })
        setWishlisted(false)
        if (onWishlistChange) onWishlistChange(courseId, false)
      } else {
        // Add to wishlist
        const response = await axios.post(url, {}, { headers })
        console.log('Post response:', response.data)
        Swal.fire({
          icon: 'success',
          title: 'Added!',
          text: 'Course added to wishlist',
          timer: 1500,
          showConfirmButton: false
        })
        setWishlisted(true)
        if (onWishlistChange) onWishlistChange(courseId, true)
      }
    } catch (error) {
      console.error('Error during wishlist toggle:', error.response || error)

      if (error.response) {
        if (error.response.status === 401) {
          Swal.fire({
            icon: 'error',
            title: 'Session Expired',
            text: 'Please login again to continue',
            confirmButtonColor: '#B8529E'
          })
          localStorage.removeItem('jwttoken')
          window.location.reload()
        } else if (error.response.data?.error === 'Course is already in the wishlist.') {
          Swal.fire({
            icon: 'info',
            title: 'Already in Wishlist',
            text: 'This course is already in your wishlist.',
            timer: 1500,
            showConfirmButton: false
          })
          setWishlisted(true)
          if (onWishlistChange) onWishlistChange(courseId, true)
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response.data?.error || 'An error occurred. Please try again.',
            confirmButtonColor: '#B8529E'
          })
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Network Error',
          text: 'Please check your internet connection and try again.',
          confirmButtonColor: '#B8529E'
        })
      }
    } finally {
      setLoading(false)
    }
  }

  // Determine icon size based on prop
  const iconSize = size === "small" ? 16 : size === "large" ? 24 : 20

  return (
    <div
      onClick={handleToggleWishlist}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: loading ? 'not-allowed' : 'pointer',
        opacity: loading ? 0.6 : 1,
        transition: "all 0.3s ease",
      }}
      title={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
      className="wishlist-icon"
    >
      {wishlisted ? (
        <IoHeart 
          style={{ 
            color: "#B8529E", 
            fontSize: `${iconSize}px`,
            transition: "all 0.3s ease"
          }} 
        />
      ) : (
        <IoHeartOutline 
          style={{ 
            color: "#666", 
            fontSize: `${iconSize}px`,
            transition: "all 0.3s ease"
          }} 
        />
      )}
    </div>
  )
}

export default WishlistButton